import React, { useContext } from 'react';
import assetAccountContext from '../../context/assetAccountContext';
import { PAMBeaconButton } from '../../utils/beacon';

import './AccountPickerBar.scss';

type Props = {};

const AccountPickerBar: React.FC<Props> = () => {
  const { hasMultipleAccounts, selectedAccount, handleChangeAccount } =
    useContext(assetAccountContext);

  if (selectedAccount === undefined) {
    return <div>No Account Selected</div>;
  }

  const handleAccountChangeClick = () => {
    if (handleChangeAccount) {
      handleChangeAccount();
    }
  };

  return (
    <>
      <div className="account-bar">
        <span className="account-name">{selectedAccount.accountName}</span>
        {hasMultipleAccounts && (
          <div className="changeAccount">
            <PAMBeaconButton
              variant="secondary"
              scale="mini"
              onClick={handleAccountChangeClick}>
              CHANGE ACCOUNT
            </PAMBeaconButton>
          </div>
        )}
      </div>
    </>
  );
};

export default AccountPickerBar;
